import { formatDistanceStrict, fromUnixTime } from "date-fns/esm";
import { ToolSet } from "ai";
import { createSelector } from "reselect";

import { getNowDateTime, INVALID_DATE } from "utils/date";
import { McpToolSet } from "components/AssistantPanel/types";

import type { ChatBudgetUsage } from "./useStore";
import { processTools } from "../helpers";

export const selectIsBudgetExhausted = (budgetUsage: ChatBudgetUsage | undefined) =>
  !!budgetUsage && budgetUsage.usedTokens >= budgetUsage.totalTokens;

export const selectBudgetResetsIn = (budgetUsage: ChatBudgetUsage) => {
  try {
    return formatDistanceStrict(fromUnixTime(budgetUsage.tokensResetAt), getNowDateTime());
  } catch {
    return INVALID_DATE;
  }
};

export const selectChatTools = createSelector(
  (mcpFilteredTools: McpToolSet | undefined) => mcpFilteredTools,
  (_mcpFilteredTools: McpToolSet | undefined, frontendTools: ToolSet | undefined) => frontendTools,
  (mcpFilteredTools, frontendTools) => [
    ...processTools(mcpFilteredTools ?? {}),
    ...processTools(frontendTools ?? {}),
  ]
);
